import { render } from "./nest_header.vue?vue&type=template&id=5a038494"
import script from "./nest_header.vue?vue&type=script&lang=js"
export * from "./nest_header.vue?vue&type=script&lang=js"

import "./nest_header.vue?vue&type=style&index=0&id=5a038494&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__